import Swiper from 'swiper/dist/js/swiper.min';
import Api from '../../../base/script/api';
import PopupProjectsObject from './popup-projects-object.pug';
import InputCountry from '../../../core/input/country/input-country';

const changeSlidesClasses = (list, index, className) => {
  if (list.length) {
    const activeSlide = list.find(el => el.classList.contains(className));
    if (activeSlide) {
      activeSlide.classList.remove(className);
      list[index].classList.add(className);
    }
  }
};

export default {
  props: {
    content: {
      type: Object,
      // default: () => {},
    },
  },
  template: PopupProjectsObject(),
  delimiters: ['${', '}}'],
  components: {
    InputCountry,
  },
  data() {
    return {};
  },
  methods: {
    closePopup() {
      this.$emit('on-close-handler');
    },
    openPopup() {
      if (this.$refs.form) {
        const elements = [].slice.call(this.$refs.form);
        if (elements.length) {
          Api.post(this.$refs.form.action, this.getFormData(elements)).then((response) => {
            if (response.data) {
              this.$emit('on-close-handler');
            }
          });
        }
      }
    },
    getFormData(list = []) {
      const data = {};
      list.forEach((item) => {
        if (item.type === 'radio') {
          if (item.checked) {
            data[item.name] = item.value;
          }
        } else if (item.type === 'text' || item.type === 'phone') {
          data[item.name] = item.value;
        }
      });

      return data;
    },
  },
  mounted() {
    window.bodyLock.disableBodyScroll(this.$el.querySelector('.popup-projects-object__content-box'));

    const swiperContainer = this.$el.querySelector('.popup-projects-object__slider-container');
    const swiperThumbContainer = this.$el.querySelector('.popup-projects-object__slider-thumb-container');
    const thumbSlides = [].slice.call(this.$el.querySelectorAll('.popup-projects-object__thumb-slide'));
    if (swiperContainer && swiperThumbContainer) {
      // eslint-disable-next-line no-unused-vars
      let activeSlide = 0;
      setTimeout(() => {
        const thumbSliderInstance = new Swiper(swiperThumbContainer, {
          slideToClickedSlide: true,
          slidesPerView: 'auto',
        });

        const sw = new Swiper(swiperContainer, {
          navigation: {
            nextEl: this.$el.querySelector('.popup-projects-object__slider-button--next'),
            prevEl: this.$el.querySelector('.popup-projects-object__slider-button--prev'),
          },
          pagination: {
            el: this.$el.querySelector('.popup-projects-object__pagination'),
            type: 'fraction',
          },
          thumbs: {
            slider: thumbSliderInstance,
          },
          on: {
            slideChange() {
              activeSlide = sw.activeIndex;
              changeSlidesClasses(thumbSlides, activeSlide, 'popup-projects-object__thumb-slide--active');
            },
          },
        });

        if (thumbSlides.length) {
          thumbSlides.forEach((slide, index) => {
            slide.addEventListener('click', () => {
              activeSlide = index;
              changeSlidesClasses(thumbSlides, activeSlide, 'popup-projects-object__thumb-slide--active');
              if (sw) {
                sw.slideTo(activeSlide);
              }
            });
          });
        }
      }, 0);
    }
  },
};



// WEBPACK FOOTER //
// ./new-blocks/popup/projects-object/popup-projects-object.js